import type { ReactNode } from 'react';

import { atom } from 'jotai';

export type InfoBottomSheetState = {
    content: ReactNode;
    isOpen: boolean;
    title: ReactNode;
};

export const emptyInfoBottomSheetState: InfoBottomSheetState = {
    content: null,
    isOpen: false,
    title: null,
};

export const infoBottomSheetAtom = atom<InfoBottomSheetState>(emptyInfoBottomSheetState);
